import { Modal } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { AuthGuard, ErrorMessage, LoadingIndicator, Page, RenderGuard } from 'components';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Lesson, Slot } from 'services';
import { curriculum_manager } from "utils/constants";
import useErrorCatcher from "utils/useErrorCatcher";
import AddSlot from "./components/AddSlot";
import Calendar from "./components/Calendar";
import CalendarList from "./components/CalendarList";
import Toolbar from "./components/Toolbar";

const useStyles = makeStyles(theme => ({
  root: {},
  spinner: {
    marginTop: theme.spacing(3),
  },
}));

let mounted = false;

const LessonSlots = () => {
  const model = useSelector(state => state.models.lesson);
  const [date, setDate] = useState(moment());
  const [view, setView] = useState('dayGridMonth');
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
  }, [date])

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, []);

  useEffect(() => {
    reload();
  }, [date]); //eslint-disable-line

  const reload = async () => {
    setLoading(true);
    await runAsyncBlock(async () => {
      let { models } = await Slot.list({
        query: {
          lesson: model.id,
          start_at: `${date.startOf("month").unix()},${date.endOf("month").unix()}`,
          end_at: `${date.startOf("month").unix()},${date.endOf("month").unix()}`,
          limit: 9999,
          sort: "start_at:asc"
        }
      });
      if (mounted) {
        setSlots(models);
      }
    }).finally(() => { mounted && setLoading(false) });
  }

  const [slotModal, setSlotModal] = useState({
    open: false,
    slot: null
  });
  const classes = useStyles();
  if (!model) {
    return null;
  }


  const handleSlotNew = () => {
    setSlotModal({
      open: true,
      slot: null
    });
  };

  const handleViewChange = view => {
    setView(view);
  };

  const handleDateToday = () => {
    setDate(moment());
  };

  const handleDatePrev = () => {
    setDate(moment(date).subtract(1, "M"));
  };

  const handleDateNext = () => {
    setDate(moment(date).add(1, "M"));
  };

  const handleModalClose = () => {
    setSlotModal({
      open: false,
      slot: null
    });
  };

  const handleSlotAdd = slots => {
    setLoading(true);
    runAsyncBlock(async () => {
      await Lesson.add_slots(model.id, { slots });
      reload();
    }).finally(() => {
      mounted && setLoading(false);
      handleModalClose();
    });
  };

  return (
    <AuthGuard roles={[curriculum_manager]}>
      <Page className={classes.root} title="Lesson Slots">
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator className={classes.spinner} variant="card" active={loading} />
        <Toolbar
          date={date}
          onDateNext={handleDateNext}
          onDatePrev={handleDatePrev}
          onDateToday={handleDateToday}
          onSlotAdd={handleSlotNew}
          onViewChange={handleViewChange}
          view={view}
        />
        <RenderGuard renderIf={view === "dayGridMonth"}>
          <Calendar date={date} slots={slots} />
        </RenderGuard>
        <RenderGuard renderIf={view === "list"}>
          <CalendarList date={date} slots={slots} />
        </RenderGuard>
        <Modal
          onClose={handleModalClose}
          open={slotModal.open}
        >
          <AddSlot
            slot={slotModal.slot}
            onAdd={handleSlotAdd}
            onCancel={handleModalClose}
          />
        </Modal>
      </Page>
    </AuthGuard>
  );
};

LessonSlots.propTypes = {
  className: PropTypes.string
};

export default LessonSlots;
